import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsBaseDirective } from './tabs-base/tabs-base.directive';
import { TabsListDirective } from './tabs-list/tabs-list.directive';
import { TabsTabDirective } from './tabs-tab/tabs-tab.directive';
import { TabContentComponent } from './tab-content.component';
import { TabComponent } from './tab.component';
import { TabViewComponent } from './tabview.component';

@NgModule({
  declarations: [
    TabsBaseDirective,
    TabsListDirective,
    TabsTabDirective,
    TabContentComponent,
    TabComponent,
    TabViewComponent,
  ],
  imports: [CommonModule],
  exports: [
    TabsBaseDirective,
    TabsListDirective,
    TabsTabDirective,
    TabContentComponent,
    TabComponent,
    TabViewComponent,
  ],
})
export class TabsModule {}
